<section class="faq-section" *ngIf="faqContent && faqContent.faqActive">
  <div class="box">
    <h2 id="faqSection" class="leftSide section-title sub-heading" [innerHTML]="faqContent?.heading"></h2>
    <div class="rightSide section-title1"><a *ngIf="label" href="javascript:;" [attr.aria-expanded]="expandAll"
        (click)="toggleExpandAll()" [innerHTML]="label"></a></div>
    <div class="content faq-content floatclear">
      <div class="col">
        <app-matlist [expandAll]="expandAll" *ngFor="let faq of faqContent?.faqs;let faqIndex=index;"
          [header]="faq.navTitle | safeHtml" [content]="faq.content | safeHtml" [item]="faqIndex"></app-matlist>
      </div>
    </div>
    <div class="spacer" role="presentation" aria-hidden="true"></div>
  </div>
</section>